import type { PiniaColadaOptions } from '@pinia/colada'

export default {
  queryOptions: {
    staleTime: 30_000,
    refetchOnWindowFocus: false,
  },
} satisfies PiniaColadaOptions
